export type currencyCodesType = {
  currencyCode: string;
  currencyName: string;
  country: string;
};

export const CURRENCY_CODES = [
  {
    currencyCode: "AED",
    currencyName: "UAE Dirham",
    country: "United Arab Emirates"
  },
  {
    currencyCode: "AMD",
    currencyName: "Armenian Dram",
    country: "Armenia"
  },
  {
    currencyCode: "AUD",
    currencyName: "Australian Dollar",
    country: "Australia"
  },
  {
    currencyCode: "AZN",
    currencyName: "Azerbaijani Manat",
    country: "Azerbaijan"
  },
  {
    currencyCode: "UAH",
    currencyName: "Ukrainian Hryvnia",
    country: "Ukraine"
  },
  {
    currencyCode: "BYN",
    currencyName: "Belarusian Ruble",
    country: "Belarus"
  },
  {
    currencyCode: "CAD",
    currencyName: "Canadian Dollar",
    country: "Canada"
  },
  {
    currencyCode: "CHF",
    currencyName: "Swiss Franc",
    country: "Switzerland"
  },
  {
    currencyCode: "CNY",
    currencyName: "Chinese Renminbi",
    country: "China"
  },
  {
    currencyCode: "CZK",
    currencyName: "Czech Koruna",
    country: "Czech Republic"
  },
  {
    currencyCode: "DKK",
    currencyName: "Danish Krone",
    country: "Denmark"
  },
  {
    currencyCode: "EUR",
    currencyName: "Euro",
    country: "European Union"
  },
  {
    currencyCode: "GBP",
    currencyName: "Pound Sterling",
    country: "United Kingdom"
  },
  {
    currencyCode: "GEL",
    currencyName: "Georgian Lari",
    country: "Georgia"
  },
  {
    currencyCode: "ILS",
    currencyName: "Israeli New Shekel",
    country: "Israel"
  },
  {
    currencyCode: "INR",
    currencyName: "Indian Rupee",
    country: "India"
  },
  {
    currencyCode: "ISK",
    currencyName: "Icelandic Króna",
    country: "Iceland"
  },
  {
    currencyCode: "JPY",
    currencyName: "Japanese Yen",
    country: "Japan"
  },
  {
    currencyCode: "KRW",
    currencyName: "South Korean Won",
    country: "South Korea"
  },
  {
    currencyCode: "KZT",
    currencyName: "Kazakhstani Tenge",
    country: "Kazakhstan"
  },
  {
    currencyCode: "NOK",
    currencyName: "Norwegian Krone",
    country: "Norway"
  },
  {
    currencyCode: "NZD",
    currencyName: "New Zealand Dollar",
    country: "New Zealand"
  },
  {
    currencyCode: "PLN",
    currencyName: "Polish Złoty",
    country: "Poland"
  },
  {
    currencyCode: "RUB",
    currencyName: "Russian Ruble",
    country: "Russia"
  },
  {
    currencyCode: "SAR",
    currencyName: "Saudi Riyal",
    country: "Saudi Arabia"
  },
  {
    currencyCode: "SEK",
    currencyName: "Swedish Krona",
    country: "Sweden"
  },
  {
    currencyCode: "SGD",
    currencyName: "Singapore Dollar",
    country: "Singapore"
  },
  {
    currencyCode: "TRY",
    currencyName: "Turkish Lira",
    country: "Turkey"
  },
  {
    currencyCode: "USD",
    currencyName: "United States Dollar",
    country: "United States"
  }
];
